var map = {
	"./common/empty.png": 25415,
	"./common/frame-corner-bottom-left.png": 45083,
	"./common/frame-corner-bottom-right.png": 55076,
	"./common/frame-corner-top-left.png": 54013,
	"./common/frame-corner-top-right.png": 18686,
	"./common/gift.png": 14752,
	"./common/hot.gif": 34102,
	"./event/top-bg.png": 36050,
	"./event/top-right.png": 58917,
	"./event/top-shell-bg.png": 40881,
	"./footer/border-body.png": 78357,
	"./footer/border-top.png": 14472,
	"./header/dropdown-arrow.png": 78829,
	"./header/menu-toggle.png": 5802,
	"./header/mobile-arrow.png": 14580,
	"./home/banner-bg.png": 1288,
	"./home/category-favorite.webp": 20576,
	"./home/category-hot-active.png": 52507,
	"./home/category-hot.png": 2262,
	"./home/category-popular.webp": 94869,
	"./home/category-recent-active.png": 23667,
	"./home/category-recent.png": 34942,
	"./home/category-recent.webp": 40391,
	"./home/category-slots.webp": 97509,
	"./home/event-card-corner-bottom-left.png": 29651,
	"./home/event-card-corner-bottom-right.png": 28956,
	"./home/event-card-corner-top-left.png": 50981,
	"./home/event-card-corner-top-right.png": 40614,
	"./home/frame-corner-bottom-left.png": 53461,
	"./home/frame-corner-bottom-right.png": 49878,
	"./home/frame-corner-top-left.png": 73571,
	"./home/frame-corner-top-right.png": 13004,
	"./home/game-section-header-bg.png": 4382,
	"./home/jackpot-bg.png": 16186,
	"./home/notice-icon.webp": 64481,
	"./home/page-bg.png": 42533,
	"./home/redeem-code-icon.png": 31240,
	"./home/search-active.png": 65265,
	"./home/search.png": 96248,
	"./login/exit-confirm-bg.png": 76347,
	"./login/popup-bg.png": 54322,
	"./notification/bg-top1.png": 35150,
	"./person/avatar.png": 19877,
	"./person/bg-vip.png": 33209,
	"./person/bg-vipBottom.png": 8332,
	"./person/bg-vipPc.png": 11202,
	"./person/icon-Deposit.png": 24644,
	"./person/icon-DepositVip.png": 94307,
	"./person/icon-History.png": 27190,
	"./person/icon-Install.png": 59907,
	"./person/icon-Notification.png": 76353,
	"./person/icon-Senha.png": 1193,
	"./person/icon-Transaction.png": 89890,
	"./person/icon-Withdraw.png": 23030,
	"./person/icon-arrow.png": 40225,
	"./person/icon-betsVip.png": 41187,
	"./person/icon-exchange.png": 72203,
	"./person/icon-service.png": 77663,
	"./person/icon_Wallet.png": 65477,
	"./person/icon_copy.png": 52857,
	"./person/icon_logout.png": 68008,
	"./person/icon_notification.png": 60643,
	"./person/vip-center-bg.png": 68803,
	"./share/TreasureChest.png": 97778,
	"./share/TreasureLock.png": 87732,
	"./share/TreasureUnLock.png": 3345,
	"./share/bg-shareMoney.png": 4529,
	"./share/bg-sharePeople.png": 6652,
	"./share/bg-top.png": 23385,
	"./share/facebook.png": 12970,
	"./share/icon_fackbook.png": 9572,
	"./share/icon_howShare.png": 5161,
	"./share/icon_ins.png": 95632,
	"./share/icon_inviteDate.png": 20789,
	"./share/icon_telegram.png": 41151,
	"./share/icon_tiktok.png": 31972,
	"./share/icon_whatsapp.png": 7020,
	"./share/icon_x.png": 8416,
	"./share/icon_youtube.png": 60139,
	"./share/invite_banner1.png": 95123,
	"./share/invite_banner2.png": 49368,
	"./share/invite_banner3.png": 70497,
	"./share/invite_banner4.png": 52782,
	"./share/proxy.png": 45728,
	"./share/redemption-code-title.png": 87390,
	"./share/share_bg.png": 58199,
	"./share/trumpet.png": 98483,
	"./sidebar/affiliate-active.png": 95289,
	"./sidebar/affiliate.png": 53392,
	"./sidebar/copy.png": 94122,
	"./sidebar/customer-service.png": 36019,
	"./sidebar/hot-bg.png": 89606,
	"./sidebar/invite-free.png": 80039,
	"./sidebar/language-arrow.png": 7211,
	"./sidebar/menu-item-border.png": 19123,
	"./sidebar/path-arrow.png": 99832,
	"./sidebar/promotion-active.png": 74707,
	"./sidebar/promotion.png": 19518,
	"./sidebar/redemption-code-active.png": 84399,
	"./sidebar/redemption-code.png": 20226,
	"./sidebar/refresh.png": 80108,
	"./sidebar/share-panel-bg.png": 22261,
	"./sidebar/sidebar-border.png": 54814,
	"./sidebar/social-media-active.png": 2284,
	"./sidebar/social-media.png": 19591,
	"./sidebar/telegram.gif": 56999,
	"./sidebar/vip-active.png": 88233,
	"./sidebar/vip-badge.png": 85606,
	"./sidebar/vip.png": 13120,
	"./signIn/suo.png": 42126,
	"./signIn/vipicon.png": 80563,
	"./signIn/vipiconact.png": 35663,
	"./tabbar/active-corner-bottom-left.png": 80861,
	"./tabbar/active-corner-bottom-right.png": 57342,
	"./tabbar/active-corner-top-left.png": 77723,
	"./tabbar/active-corner-top-right.png": 2148,
	"./tabbar/affiliate-active.png": 65431,
	"./tabbar/affiliate.png": 35962,
	"./tabbar/home-active.png": 46439,
	"./tabbar/home.png": 78570,
	"./tabbar/menu-active.png": 44503,
	"./tabbar/menu.png": 61754,
	"./tabbar/profile-active.png": 38041,
	"./tabbar/profile.png": 28464,
	"./tabbar/sport.png": 54961,
	"./tabbar/vip-active.png": 19371,
	"./tabbar/vip.png": 12582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86007;